/**
 * 会话列表排序单点（任务 8a）：isTop → lastMsgTimestamp → lastMsgId，全部降序。
 * 与服务端 `order by is_top desc, last_msg_time desc` 一致，再以 lastMsgId 决胜——
 * 同毫秒多条消息时顺序确定，对账前后列表不抖（requests 场景 B）。
 *
 * 纯模块（零依赖，不 import Worker 代码）：Worker 出快照前排序、主线程收推送后
 * 重排，两端共用这一份，口径不会分叉。
 */

export interface ConversationOrderKey {
  readonly isTop: number;
  readonly lastMsgTimestamp: number;
  readonly lastMsgId: number;
}

export function compareConversations(a: ConversationOrderKey, b: ConversationOrderKey): number {
  if (a.isTop !== b.isTop) return b.isTop - a.isTop;
  if (a.lastMsgTimestamp !== b.lastMsgTimestamp) return b.lastMsgTimestamp - a.lastMsgTimestamp;
  return b.lastMsgId - a.lastMsgId;
}
